import { useRouter } from 'next/router';

import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation-10';

import { updateFloorPlanRoomForRent } from '../../../hooks/queries/listingDetailsCache';
import { useGetListingDetails } from '../../../hooks/queries/properties';
import { useFieldSave } from '../../../hooks/useFieldSave';
import { useMultiEditMutation } from '../../../hooks/useMultiEditMutation';

const inputName = 'monthlyUtilitiesShareDescription';

const RoomUtilitiesFormField = ({ isRelistingFieldset = false }: { isRelistingFieldset?: boolean }) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;
  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const floorPlans = listingDetails?.floorPlans || [];
  const floorPlanId = floorPlans[0]?.id;
  const initialUtilities = floorPlans[0]?.roomForRent?.monthlyUtilitiesShareDescription ?? '';

  const updateMutation = useMultiEditMutation({
    applyToCache: ({ postData }) => updateFloorPlanRoomForRent(postData.floorPlans),
  });

  const utilitiesField = useFieldSave({
    fieldName: inputName,
    initialValue: initialUtilities,
    mutation: updateMutation,
    buildMutationVariables: (value) =>
      floorPlanId
        ? {
            postData: {
              property: {
                listingAlias,
              },
              floorPlans: [
                {
                  id: floorPlanId,
                  roomForRent: { monthlyUtilitiesShareDescription: value },
                },
              ],
            },
          }
        : null,
  });

  return (
    <FormField
      data-testid="RoomUtilitiesFormField"
      label={<Label size={isRelistingFieldset ? 'lg' : 'md'}>Monthly utilities</Label>}
      error={!!utilitiesField.error}
      description={<FormHelp>{utilitiesField.error}</FormHelp>}
    >
      <Textarea
        name={inputName}
        value={utilitiesField.value}
        rows={10}
        onChange={(e) => utilitiesField.onChange(e.target.value)}
        onBlur={utilitiesField.onBlur}
      />
    </FormField>
  );
};

export default RoomUtilitiesFormField;
